module.exports = __webpack_public_path__ + "media/acuity/syntax_logo-9b86050f.svg";